import axios, { CancelToken } from 'axios'

import config from './config'

type UploadOptions = {
  onProgress?: (percent: number) => void
  cancelToken?: CancelToken
}

/**
 * Uploads a file to S3 under the flat `media/` folder via the shared
 * presigned-url endpoint. Called with just a file it behaves exactly as
 * before; the Media Library passes the optional progress/cancel hooks it
 * needs for bulk uploads.
 */
export const uploadToS3 = async (file: File, options: UploadOptions = {}) => {
  try {
    const { name, type } = file
    const response = await axios.post(`${config.API_URI}getPreSignUrl`, {
      filename: name,
      contentType: type,
    })

    const { onProgress, cancelToken } = options

    const signedUrl = response.data
    await axios.put(signedUrl, file, {
      headers: {
        'Content-Type': type,
      },
      withCredentials: false,
      cancelToken,
      onUploadProgress: event => {
        if (onProgress && event.total) {
          onProgress(Math.round((event.loaded / event.total) * 100))
        }
      },
    })

    return response.data
  } catch (err) {
    console.log(err)
    throw err
  }
}
